export default {
  title: "Субэкспоненты",
  totalArea: "Общая площадь: {area} кв. м",
  totalAreaSubexponents: "Общая площадь: {area} кв. м",

  withDeligatedAccess: "С правами на редактирование",
  withReadAccess: "С правами только на чтение",
  read: "Просмотр",
  edit: "Редактирование",
  addSubexponentBtn: "Добавить субэкспонента",
  manageSubexponentsBtn: "Управление субэкпонентами",
  lookSubexponentsBtn: "Просмотреть субэкспонентов",

  pluralize: ["субэкспонент", "субэкспонента", "субэкспонентов"],
  notConfirmed: "Не подтверждено",

  modal: {
    totalExhibitors: "Всего {amount}",

    totalQuotas: "Всего квот:",
    availableQuotas1: "Доступно",
    availableQuotas2: "для распределения:",
    availableQuotasAll: "Доступно квот:",
    availablePasses: "Доступно пропусков",
    oldYearsSubexponentTitle: "Субэкспоненты прошлых выставок",
    addSubexponentTitle: "Добавить субэкспонента",
    addSubexponentTitle2: "Создать нового субэкспонента",
    addQuotasLabel: "Квота",
    addMoreSubexponent: "Добавить ещё",
    newSubexponents: "Новые субэкспоненты",
    tooltip: "Количество бесплатных удостоверений участника",
    inn: "ИНН",

    validateEmail: "Поле должно быть эл. почтой",
    duplicationEmail: "Данный e-mail уже используется",

    SelectedSubexponents: "Выбранные субэкспоненты",

    addHint:
      "На указанный e-mail придет письмо, которое позволит активировать все возможности личного кабинета.",

    deleteAll: "Удалить всех",

    searchPlaceholder: "Поиск субэкспонента",

    viewByList: "Списком",
    viewByCards: "Карточками",

    deleteAlert:
      "Вы точно хотите удалить субэкспонента? Все созданные им пропуска будут также удалены.",
    deleteAllAlert: "Вы точно хотите удалить всех субэкспонентов?",

    accountNotActivated: "Аккаунт не активирован",
    colOrgControlsSubexp: "Вы управляете профилем субэкспонента",
    colOrgDeletegatedSubexp:
      "Вы делегировали управление профилем субэкспоненту",
    resendBtn: "Отправить код повторно",

    companyProfile: "Профиль компании",
    companyProfileFilled: "Заполнен",
    companyProfileNotFilled: "Не заполнен",
    catalogApplication: "Заявка в каталог",
    catalogApplicationSent: "Отправлена",
    catalogApplicationNotSent: "Не отправлена",
    participantPasses: "Удостоверения участников",
    carPasses: "Разовый автомобильный пропуск",

    access: "Доступ",

    recentlyAdded: "Недавно добавленные",
    selectAll: "Всех"
  }
};
